/**
 * Resolve the A/B-test weight to send with the front-page request. Extracted verbatim from
 * `useFrontPage` so it can be unit-tested in isolation. Behaviour is preserved exactly — including
 * the operator-precedence quirk that the `abTestWeight` argument acts only as a truthiness check
 * while the resolved value is always the `window` global on the client (NOA-3244). The quirk is
 * intentionally left as-is here; fixing it is tracked separately.
 */
export const resolveFrontPageWeight = (abTestWeight?: number): number | undefined =>
  // eslint-disable-next-line no-underscore-dangle
  abTestWeight || typeof window !== 'undefined' ? window.__AB_TEST_WEIGHT__ : undefined;
